/**
 * Discriminated union describing what the chat input bar should be doing.
 *
 * Computed by the parent (ChatInterface) from its various pieces of state
 * (loading, streaming, rate-limit, concurrency cooldown) and passed to the
 * input bar as a single value. The input bar reads `kind` to decide whether
 * to disable, and uses `reason` (when present) for placeholder, tooltip, and
 * countdown badge.
 */
export type ChatInputStatus =
  | { kind: 'ready' }
  | { kind: 'loading' }
  | { kind: 'streaming' }
  | {
      kind: 'rate_limited';
      /** When the rate limit window resets. */
      until: Date;
      /** User-facing message (placeholder + tooltip). */
      reason: string;
    }
  | {
      kind: 'cooldown';
      /** When the concurrency cooldown ends. */
      until: Date;
      /** User-facing message (placeholder + tooltip). */
      reason: string;
    };

/** Whether the input should be disabled for this status. */
export function isInputDisabled(status: ChatInputStatus): boolean {
  return status.kind !== 'ready';
}
